import React from 'react'
import { useTranslation } from 'react-i18next';
import GcmChartCard from '../shared/GcmChartCard';

const GcmAlerts = ({
    isTcp,
    IconMult,
    mp,
    dataAlertGCMInCancelltions,
    optionsAlertGCMInCancelltions,
    IconExcl,
    dataAlertGCMWarnings,
    optionsAlertGCMWarnings,
    IconNoAsg,
    dataAlertGCMInIssues,
    optionsAlertGCMInIssues
}) => {
    const { t } = useTranslation();

    return (
        <div className="card-early card--bottom-early">
            <p className='title-cards-early'><b>{t('extended_report.projects_with_GCM_alerts')}</b></p>

            {(isTcp) ? (
                <div className="bottom-charts-early">
                    <GcmChartCard
                        Icon={IconMult}
                        title={t('extended_report.tc_in_cancelation')}
                        value={mp.GcmAlerts.totalCountCancellation}
                        projectsLabel={t('one_pager_report.projects')}
                        data={dataAlertGCMInCancelltions}
                        options={optionsAlertGCMInCancelltions}
                    />

                    <GcmChartCard
                        Icon={IconExcl}
                        title={t('extended_report.ct_warning')}
                        value={mp.GcmAlerts.totalCountWarning}
                        projectsLabel={t('one_pager_report.projects')}
                        data={dataAlertGCMWarnings}
                        options={optionsAlertGCMWarnings}
                    />

                    <GcmChartCard
                        Icon={IconNoAsg}
                        title={t('extended_report.tc_with_active_problems')}
                        value={mp.GcmAlerts.totalCountIssue}
                        projectsLabel={t('one_pager_report.projects')}
                        data={dataAlertGCMInIssues}
                        options={optionsAlertGCMInIssues}
                    />
                </div>
            ) : (
                <div className='na-content' style={{ minHeight: '100px' }}>
                    <p>N/A</p>
                </div>
            )}
        </div>
    )
}

export default GcmAlerts